import { NextPage } from "next";
import React from "react";
import { Layout } from "../layout/Layout";


export const IndexPage: NextPage = () => (<Layout />)


export default IndexPage
